import { createFileRoute } from "@tanstack/react-router";
import { MegaphoneIcon } from "lucide-react";
import { BroadcastsView } from "@/components/broadcasts/broadcasts-view";
import { broadcastEmployeeMetaQuery, broadcastListsQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/broadcasts")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureQueryData(broadcastEmployeeMetaQuery));
    warm(context.queryClient.ensureQueryData(broadcastListsQuery));
  },
  component: BroadcastsPage,
});

function BroadcastsPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <MegaphoneIcon className="size-3.5" />
            Broadcast
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Message broadcast</h1>
          <p className="text-muted-foreground text-sm">
            Send an announcement to all employees or a targeted group by email.
          </p>
        </div>

        <BroadcastsView />
      </div>
    </main>
  );
}
